/*
  Halloween vibes
  Tags the Halloween menu item and the Halloween "view all" button so
  halloween-vibes.css can style them. Nothing here is required for the page to
  work: if this file does not run, the CSS fallback selectors still colour the
  plain <a href="/collections/halloween"> links.

  The collection handle is read from window.hwCollectionHandle (set in
  layout/theme.liquid) so there is one place to change it.
*/
(function () {
  var handle = (window.hwCollectionHandle || 'halloween').toLowerCase();

  // True for /collections/halloween, /pages/halloween and their localised
  // variants (/de/collections/halloween), but not for /collections/x-halloween.
  function isHalloweenLink(a, collectionOnly) {
    var path;
    try {
      path = new URL(a.href, window.location.origin).pathname;
    } catch (e) {
      return false;
    }
    path = path.replace(/\/+$/, '').toLowerCase();
    if (collectionOnly && path.indexOf('/collections/') === -1) return false;
    return path.split('/').pop() === handle;
  }

  // Decorative icons are injected rather than drawn with ::after, so each one
  // can animate on its own and sit tight against the label. aria-hidden keeps
  // them out of the accessible name of the link.
  function addIcons(el, html, className) {
    if (el.querySelector('.' + className)) return;
    var box = document.createElement('span');
    box.className = className;
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML = html;

    // Menu items with a submenu end in an arrow or caret icon, so slot the
    // decoration in before that instead of after it.
    var icon = el.querySelector('.svg-wrapper, svg');
    if (icon) {
      el.insertBefore(box, icon);
    } else {
      el.appendChild(box);
    }
  }

  function decorateNav(el) {
    addIcons(el, '<i class="hw-i hw-i--pumpkin"></i>', 'hw-nav-icons');
    el.classList.add('hw-nav--js');
  }

  function decorateButton(el) {
    addIcons(el, '<i></i><i></i><i></i>', 'hw-bats');
    el.classList.add('hw-button--js');
  }

  function tagMenu(root) {
    var scope = root || document;

    // Top level items that open a submenu carry the handle in their id.
    scope
      .querySelectorAll('#HeaderMenu-' + handle + ', #HeaderDrawer-' + handle)
      .forEach(function (el) {
        el.classList.add('hw-nav');
        el.classList.add('hw-nav--bat');
        decorateNav(el);
      });

    scope.querySelectorAll('.header a[href], .menu-drawer a[href]').forEach(function (a) {
      if (!isHalloweenLink(a)) return;
      a.classList.add('hw-nav');

      // Skip the icons when a parent (a summary, say) already carries them.
      if (a.parentElement && a.parentElement.closest('.hw-nav--bat')) return;

      a.classList.add('hw-nav--bat');
      decorateNav(a);
    });
  }

  function tagButtons(root) {
    (root || document)
      .querySelectorAll('.collection__view-all a[href]')
      .forEach(function (a) {
        if (!isHalloweenLink(a, true)) return;
        a.classList.add('hw-button');
        decorateButton(a);
      });
  }

  function run(root) {
    tagMenu(root);
    tagButtons(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  // Re-run when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
